import { loading, mode, noTransferOpen, open } from "./service";

/**
 * Handles event bus registrations for shipment modal
 */
export const registerConsignmentEvents = (eventBus: any, setSender: () => void) => {
  return {
    register: () => {
      eventBus.$on("NEW_CONSIGNMENT_CREATED", setSender);
      eventBus.$on("NEW_CONSIGNMENT_OPEN", () => {
        noTransferOpen.value = false;
        open.value = true;
        setSender();
        mode.value = "new";
      });

      eventBus.$on("NEW_CONSIGNMENT_CLOSE", () => {
        open.value = false;
        mode.value = "new";
      });
    },
    unregister: () => {
      eventBus.$off("NEW_CONSIGNMENT_OPEN");
      eventBus.$off("NEW_CONSIGNMENT_CLOSE");
    },
  };
};

/**
 * Handles form submission process
 */
export const submitConsignmentForm = async (formData: any, homeFetch: any) => {
  loading.value = true;

  // Prepare API request payload
  const data = {
    consignment: {
      sender: {
        ...formData.sender,
        country: formData.sender.country.toUpperCase(),
        type: formData.sender.business ? "business" : "private",
        is_business: formData.receiver.business,
        name: formData.sender.name,
        attention: formData.sender.attention,
      },
      receiver: {
        ...formData.receiver,
        country: formData.receiver.country.toUpperCase(),
        type: formData.receiver.business ? "business" : "private",
        is_business: formData.receiver.business,
        name: formData.receiver.name,
        attention: formData.receiver.attention,
      },
      customer_contact_id: formData.customer_contact_id || null,
      carrier: "homerunner",
      carrier_product: "business",
      carrier_service: "prebook",
      reference: formData.reference,
      description: formData.description,
      comment: formData.comment,
      label_format: "LabelPrint",
      servicepoint_id: 0,
      prebook: true,
      packages: Array.from({ length: formData.quantity }, () => ({
        width: formData.width,
        length: formData.length,
        height: formData.height || 0,
        weight: 0,
        order_lines: [],
      })),
    },
    final_url: window.location.origin + "/redirects/order/success",
  };

  // Submit the consignment creation request
  try {
    const response = await homeFetch("consignments", {
      method: "POST",
      body: data,
    });

    EventBus?.$emit("NEW_CONSIGNMENT_CREATED");
    return response;
  } catch (_error) {
    loading.value = false;
    return null;
  }
};
